// extracted by mini-css-extract-plugin
export default {"modal":"lt","topline":"mt","img":"nt","textcontents":"ot","heading":"pt","copy":"qt","link":"rt","close":"st","modalinner":"tt","container":"ut"};
    if(module.hot) {
      // 1713969925883
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  